import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReportLoadsService } from 'src/app/infrastructure/services/report-loads.service';
import {
  ReportLoad,
  ReportLoadPage
} from '@model/report-load/report-load.model';

@Injectable({
  providedIn: 'root'
})
export class ReportLoadsGateway {
  private readonly reportLoadsService = inject(ReportLoadsService);

  getLoadsByDNI(
    dni: string,
    page: number,
    size: number
  ): Observable<ReportLoadPage> {
    return this.reportLoadsService.getLoadsByDNI(dni, page, size);
  }

  getLoadsByPolicy(
    policyNumber: string,
    page: number,
    size: number
  ): Observable<ReportLoadPage> {
    return this.reportLoadsService.getLoadsByPolicy(policyNumber, page, size);
  }

  getLoadById(loadId: string): Observable<ReportLoad> {
    return this.reportLoadsService.getLoadById(loadId);
  }

  deleteLoad(loadId: string): Observable<void> {
    return this.reportLoadsService.deleteLoad(loadId);
  }
}
